export function truncateFilename(filename: string, maxLength: number = 16): string {
  if (filename.length <= maxLength) return filename;
  const extMatch = filename.match(/\.[^.]+$/);
  const ext = extMatch ? extMatch[0] : "";
  const nameWithoutExt = ext ? filename.slice(0, -ext.length) : filename;
  const availableLength = maxLength - 3 - ext.length; // 3 for "..."
  const startLength = Math.ceil(availableLength / 2);
  const endLength = Math.floor(availableLength / 2);
  return nameWithoutExt.slice(0, startLength) + "..." + nameWithoutExt.slice(-endLength) + ext;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
  return (bytes / (1024 * 1024)).toFixed(1) + " MB";
}
